import { NavigationPathsEnum } from "@utilities/enums";
import { FC, ReactNode } from "react";
import { useControllers } from "./useControllers";
import { PageWrapper } from "../pageWrapper";

interface Props {
    activeTab: NavigationPathsEnum;
    children: ReactNode;
}

export const SettingPageWrapper: FC<Props> = ({ activeTab, children }) => {

    const { 
        tabs,
        onToggleDrawer,
        handleTabClick,
    } = useControllers();

    return (
        <PageWrapper
            withSubMenu
            activeStack="settingsStack"
            onCustomMenuButtonPress={onToggleDrawer}
        >
            <div className="lg:hidden drawer drawer-end">
                <input
                    id="my-drawer-4"
                    type="checkbox"
                    className="drawer-toggle"
                />
                <div className="z-20 drawer-side">
                    <label
                        htmlFor="my-drawer-4"
                        aria-label="close sidebar"
                        className="drawer-overlay"
                    />
                    <ul className="menu bg-base-200 text-base-content min-h-full w-80 p-4">
                        {
                            tabs.map((tab, i) => {
                                if (tab.isHide) return null;

                                return (
                                    <li key={i} className={tab.disabled ? "opacity-50" : ""}>
                                        <label
                                            className={`${activeTab === tab.link ? "bg-primary text-white" : ""}`}
                                            onClick={() => handleTabClick(tab)}
                                            style={{ cursor: tab.disabled ? "not-allowed" : "pointer" }}
                                        >
                                            {tab.label}
                                        </label>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>


            <div className="hidden md:block mt-2 mx-3">
                <div
                    role="tablist"
                    className="tabs bg-white items-center tabs-boxed col-span-full shadow overflow-x-auto h-14"
                >
                    {
                        tabs.map((tab, i) => {
                            if (tab.isHide) return null;
                            
                            return (
                                <label
                                    key={i}
                                    role="tab"
                                    className={`tab ${activeTab === tab.link ? "tab-active h-full" : ""} ${tab.disabled ? "opacity-50" : ""}`}
                                    onClick={() => handleTabClick(tab)}
                                    style={{ cursor: tab.disabled ? "not-allowed" : "pointer" }}
                                >
                                    {tab.label}
                                </label>
                            )
                        })
                    }
                </div>
            </div>

            {/* Contenu principal */}
            <div className="p-5 md:p-5 overflow-auto" style={{ height: "calc(100vh - 120px)" }}>
                {children}
            </div>
        </PageWrapper>
    );
};
